exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-alert .sweet-modal.is-alert .sweet-content{padding:60px 32px 40px 32px}", ""]);

// exports
